import React, { Component, Fragment } from "react";
import styled from "styled-components";

import { Config } from "../../Config";

const monthNames = ["January", "February", "March", "April", "May", "June",
"July", "August", "September", "October", "November", "December"
];

function numberFormat(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function ucfirst(str) {
  str = str.toLowerCase(); // Convert the entire string to lowercase
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function ucfirst_every_word(str) {
  return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

function numberToWords(num) {
  const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

  if (num === 0) return '';
  if (num < 20) return ones[num];
  if (num < 100) {
    return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + ones[num % 10] : '');
  }
  if (num < 1000) {
    return ones[Math.floor(num / 100)] + ' hundred' + (num % 100 !== 0 ? ' and ' + numberToWords(num % 100) : '');
  }
  if (num < 1000000) {
    return numberToWords(Math.floor(num / 1000)) + ' thousand' + (num % 1000 !== 0 ? ' ' + numberToWords(num % 1000) : '');
  }
  if (num < 1000000000) {
    return numberToWords(Math.floor(num / 1000000)) + ' million' + (num % 1000000 !== 0 ? ' ' + numberToWords(num % 1000000) : '');
  }
  if (num < 1000000000000) {
    return numberToWords(Math.floor(num / 1000000000)) + ' billion' + (num % 1000000000 !== 0 ? ' ' + numberToWords(num % 1000000000) : '');
  }
  return numberToWords(Math.floor(num / 1000000000000)) + ' trillion' + (num % 1000000000000 !== 0 ? ' ' + numberToWords(num % 1000000000000) : '');
}

function formatTerbilang(angka) {
  if (angka === 0) return 'zero rupiah';
  return numberToWords(angka).replace(/\s+/g, ' ').trim() + ' rupiah';
}

class Invoice extends Component {
  constructor(props) {
    super(props);

    if (this.props.label !== undefined) {
      this.state = this.props.label;
      this.state.allowdisp = true;
    } else {
      this.state = { allowdisp: false };
    }
  }

  renderItems() {
    let disp = this.state.up_detail.map((dt) => {
      return (
        <TableRow key={dt.goods_name}>
          <TableCol className="tname">{ucfirst_every_word(dt.goods_name)}</TableCol>
          <TableCol className="align-right tqty">{dt.quantity}</TableCol>
          <TableCol className="align-right tprice">{numberFormat(dt.price)}</TableCol>
          <TableCol className="align-right ttotal">{numberFormat(dt.price * dt.quantity)}</TableCol>
        </TableRow>
      );
    });

    return disp;
  }

  grandTotal() {
    let total = 0;
    this.state.spo_goods_details.forEach((dt) => {
      total += dt.price * dt.quantity;
    });

    return total;
  }

  convertDate(datestr) {
    let date_start = new Date(datestr.substr(0, 10));

    let start_year = date_start.getFullYear();
    let start_month = date_start.getMonth();
    let start_date = date_start.getDate();

    let returnstr = start_date.toString().padStart(2, "0") + " " + monthNames[start_month] + " " + start_year;

    return returnstr;
  }

  render() {
    return (
      <OuterWrap>
        <Wrapper>
          {this.state.allowdisp && (
            <>
              {/* First and additional pages */}
              <Header>
                <HeaderLeft>
                  <HeaderLogo src="new_logo_monogram.png" />
                </HeaderLeft>
                <HeaderRight>
                  <HeaderContactInfo>
                    <ContactText>(021) 7208351</ContactText>
                    <ContactText>www.pandorcakes.com</ContactText>
                    <ContactText>Jl. Wijaya 1 No.60, Jakarta Selatan</ContactText>
                  </HeaderContactInfo>
                </HeaderRight>
              </Header>
              <Recipient>
                <RecipientLeftSection>
                  <RecipientRow>
                    <RecipientLabel><b>No. Invoice</b></RecipientLabel>
                    <RecipientValue><b>{this.state.invoices[0].no_invoice}</b></RecipientValue>
                  </RecipientRow>
                  <RecipientRow>
                    <RecipientLabel>No. SPO</RecipientLabel>
                    <RecipientValue>{this.state.no_spo}</RecipientValue>
                  </RecipientRow>
                  <RecipientRow>
                    <RecipientLabel>Order Date</RecipientLabel>
                    <RecipientValue>{this.convertDate(this.state.invoices[0].invoice_date)}</RecipientValue>
                  </RecipientRow>
                  <RecipientRow>
                    <RecipientLabel>{ucfirst(this.state.packages[1]?.delivery_type)} Date</RecipientLabel>
                    <RecipientValue>{this.convertDate(this.state.packages[1]?.delivery_date)} {this.state.packages[1]?.delivery_time}:00</RecipientValue>
                  </RecipientRow>
                  <RecipientRow>
                    <RecipientLabel><b>Payment Status</b></RecipientLabel>
                    <RecipientValue><b>{this.state.invoices[0].invoice_status === 'PAID' ? 'PAID' : 'PROFORMA INVOICE'}</b></RecipientValue>
                  </RecipientRow>
                </RecipientLeftSection>
                <RecipientRightSection>
                  <BillingTitle>Issued to:</BillingTitle>
                  <BillingText>{this.state.customer.addresses[0].address_name}</BillingText>
                  <BillingText>{this.state.customer.addresses[0].street} {this.state.customer.addresses[0].postal}</BillingText>
                  <BillingText>{this.state.customer.addresses[0].phone}</BillingText>
                </RecipientRightSection>
              </Recipient>
              <TableContents>
                <TableRow>
                  <TableHeader>Item Description</TableHeader>
                  <TableHeader>Qty</TableHeader>
                  <TableHeader>Price (IDR)</TableHeader>
                  <TableHeader>Subtotal (IDR)</TableHeader>
                </TableRow>
                <TableRow>
                  <TableCol /><TableCol /><TableCol /><TableCol />
                </TableRow>
                {this.renderItems()}
                {this.state.page < this.state.totalpage && (
                  <TableRow>
                    <TableCol /><TableCol /><TableCol /><TableCol />
                  </TableRow>
                )}
                {this.state.page < this.state.totalpage && (
                  <TableRow>
                    <TableCol /><TableCol /><TableCol /><TableCol />
                  </TableRow>
                )}
                {this.state.page < this.state.totalpage && (
                  <TableRow className="bottomborder">
                    <TableCol /><TableCol /><TableCol /><TableCol />
                  </TableRow>
                )}
                {this.state.page < this.state.totalpage && (
                  <TableRow>
                    <strong><br/>continued on next page...</strong>
                  </TableRow>
                )}
              </TableContents>
              <Totals>
                {this.state.page === this.state.totalpage && (
                  <TotalRow className="grandtotalrow">
                    <TotalLeft></TotalLeft>
                    <TotalMid className="grandtotalcol">Grand Total</TotalMid>
                    <TotalRight className="grandtotalcol">IDR {numberFormat(this.grandTotal())}</TotalRight>
                  </TotalRow>
                )}
                {this.state.page === this.state.totalpage && (
                  <TerbilangRow>
                    <TerbilangText>Amount: {formatTerbilang(this.grandTotal())}</TerbilangText>
                  </TerbilangRow>
                )}
                {this.state.invoices[0].invoice_status === 'PAID' && this.state.page === this.state.totalpage && 1 == 2 &&(
                  <PaidRow>
                    <PaidText>PAID</PaidText>
                  </PaidRow>
                )}
              </Totals>
              <Footer>
                <FooterRow>
                  <PaymentInfo>
                    <PaymentInfoTitle>Payment Information</PaymentInfoTitle>
                    <PaymentInfoText>Virtual Account</PaymentInfoText>
                    <PaymentInfoText>PAND'OR FOOD AND CAKES</PaymentInfoText>
                  </PaymentInfo>
                </FooterRow>
              </Footer>
            </>
          )}
        </Wrapper>

        {/* Last page for images */}
        {this.state.allowdisp && this.state.page === this.state.totalpage && this.state.invoices[0].invoice_payments.length > 0 && (
          <LastPage>
            <ImageContainer>
              {this.state.invoices[0].invoice_payments[0].image !== null && this.state.invoices[0].invoice_payments[0].image.length > 3 &&
              <ImageBox src={
                Config.API_IMG_URL +
                "payments/" +
                this.state.invoices[0].invoice_payments[0].image
              } />
              }
              {this.state.invoices[0].invoice_payments[0].image2 !== null && this.state.invoices[0].invoice_payments[0].image2.length > 3 &&
              <ImageBox src={
                Config.API_IMG_URL +
                "payments/" +
                this.state.invoices[0].invoice_payments[0].image2
              } />
              }
            </ImageContainer>
          </LastPage>
        )}
      </OuterWrap>
    );
  }
}

const OuterWrap = styled.div``;

const Wrapper = styled.div`
  display: block;
  position: relative;
  width: 12.5cm;
  height: 17cm;
  margin-top: 1cm;
  margin-left: 0.5cm;
  padding: 5mm;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 11px;
  line-height: 1em;
`;

const LastPage = styled.div`
  display: block;
  position: relative;
  width: 12.5cm;
  height: 17cm;
  margin-top: 1cm;
  margin-left: 0.5cm;
  padding: 5mm;
  page-break-before: always;
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;

const ImageBox = styled.img`
  width: 48%;
  height: auto;
  border: 1px solid #000;
`;

const Header = styled.div`
  display:block;
  position:relative;
  width: 100%;
  border-bottom: 1px solid black;
  
  /*CLEARFIX*/
  overflow: auto;
  &:after {
      content: "";
      clear:both;
      display:table;
  }
`;

const HeaderLeft = styled.div`
  display:block;
  position:relative;
  width: 30%;
  float:left;
  
`;

const HeaderLogo = styled.img`
  display:block;
  position:relative;
  width: 90%;
  margin:auto;
  margin-bottom: 1mm;
`;

const HeaderRight = styled.div`
  display:block;
  position:relative;
  width: 65%;
  height:20mm;
  float:left;
`;

const HeaderContactInfo = styled.div`
  display:block;
  position:absolute;
  width: 100%;
  bottom: 0;
  text-align: right;
`;

const ContactText = styled.div`
  font-size: 0.9em;
  margin-bottom: 1mm;
`;

const Recipient = styled.div`
  display:block;
  position:relative;
  width: 100%;
  padding-top:3mm;
  padding-bottom: 5mm;

  /*CLEARFIX*/
  overflow: auto;
  &:after {
      content: "";
      clear:both;
      display:table;
  }
`;

const RecipientLeftSection = styled.div`
  display:block;
  position:relative;
  width: 60%;
  float:left;
`;

const RecipientRightSection = styled.div`
  display:block;
  position:relative;
  width: 40%;
  float:left;
`;

const RecipientRow = styled.div`
  display:block;
  position:relative;
  width: 100%;
  padding-bottom:1mm;

  /*CLEARFIX*/
  overflow: auto;
  &:after {
      content: "";
      clear:both;
      display:table;
  }
`;

const RecipientLabel = styled.div`
  display:block;
  position:relative;
  width: 40%;
  float:left;

  &:after {
    position: absolute;
    content: ":";
    right: 2mm;
  }
`;

const RecipientValue = styled.div`
  display:block;
  position:relative;
  width: 60%;
  float:left;
`;

const BillingTitle = styled.div`
  font-weight: bold;
  margin-bottom: 2mm;
`;

const BillingText = styled.div`
  margin-bottom: 1mm;
`;

const TextRow = styled.div`
  display:block;
  position:relative;
  width: 100%;
  font-weight: bold;
`;

const Totals = styled.div`
  display:block;
  position:relative;
  width: 100%;
`;

const TotalRow = styled .div`
  display:block;
  position:relative;
  width: 99.5%;
  padding-bottom: 2mm;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-top: 1px solid black;

  &.grandtotalrow {
    padding-top:2mm;
    /*background: #E9E9E9;*/
    border-bottom: 1px solid black;
  }
  
  /*CLEARFIX*/
  overflow: auto;
  &:after {
      content: "";
      clear:both;
      display:table;
  }
`;

const TotalLeft = styled.div`
  display:block;
  position:relative;
  width: 54%;
  float:left;
  height: 1mm;
`;

const TotalMid = styled.div`
  display:block;
  position:relative;
  width: 25%;
  text-align: right;
  float:left;
  
  &.grandtotalcol {
    font-size: 1em;
    font-weight:bold;
  }
`;


const TotalRight = styled.div`
  text-align: right;
  display:block;
  position:relative;
  width: 20%;
  padding-right:1%;
  float:left;
  
  &.grandtotalcol {
    font-size: 1em;
    font-weight:bold;
  }
`;

const PaidRow = styled .div`
  display:block;
  position:relative;
  width: 100%;
  margin-top:5mm;
  padding-bottom: 2mm;
  
  /*CLEARFIX*/
  overflow: auto;
  &:after {
      content: "";
      clear:both;
      display:table;
  }
`;

const PaidText = styled.div`
  text-align: right;
  display:block;
  position:relative;
  padding-right:1%;
  height: 4.5cm;
  line-height: 1cm;

  color: red;
  font-size:36px;
`;

const TerbilangRow = styled.div`
  display:block;
  position:relative;
  width: 100%;
  padding-top: 2mm;
  padding-bottom: 2mm;
`;

const TerbilangText = styled.div`
  font-style: italic;
  font-size: 0.95em;
`;

const TableContents = styled.table`
  display:table;
  position:relative;
  width: 100%;
  border-spacing: 0;
  margin-top: 1mm;
  font-size:11px;
`;

const TableRow = styled.tr`
  display:table-row;
  position:relative;
  width: 100%;

  &:last-child td {
    padding-bottom: 3mm;
  }
  
  &.bottomborder td {
    border-bottom: 1px solid black;
  }
`;

const TableHeader = styled.th`
  display:table-cell;
  position:relative;
  background: #E8E5E0;
  color: black;
  margin-bottom: 2mm;
  font-size: 0.9em;
  font-weight: regular !important;
  padding: 1%;
  padding-top: 2mm;
  padding-bottom: 2mm;
  border-top: 1px solid black;
  border-left: 1px solid black;

  &:last-child {
    border-right: 1px solid black;
  }
`;

const TableCol = styled.td`
  display: table-cell;
  position:relative;
  padding: 1%;
  vertical-align:top;
  font-size: 1em;
  border-left: 1px solid black;

  &:last-child {
    border-right: 1px solid black;
  }
  &.align-right {
    text-align: right;
  }
  &.tname {
    width: 56%;
  }
  &.tqty {
    width: 8%;
  }
  &.tprice {
    width: 18%;
  }
  &.ttotal {
    width: 18%;
  }
`;

const TableBoldText = styled.div`
  font-weight:bold;
  padding: 0;
  margin: 0;
  font-size: 0.8em !important;
`;

const TableRegularText = styled.div`
  padding: 0;
  margin: 2mm 1mm;
  font-size: 0.8em !important;
`;

const BoldText = styled.div`
  font-weight:bold;
  padding: 0;
  margin: 0;
  margin-bottom: 1mm;
  
  &.shippingaddress {
    margin-bottom: 3mm; 
  }
`;

const RegularText = styled.div`
  padding: 0;
  margin: 0;
  margin-bottom: 1mm;
`;

const Shipping = styled.div`
  display:block;
  position:relative;
  width: 50%;
  padding-bottom:5mm;
  float:left;
  
  &.right {
    text-align: right;
  }
`;

const Footer = styled.div`
  display:block;
  position:absolute;
  bottom: 0;
  width: 92%;
  padding-bottom:10mm;
`;

const FooterRow = styled.div`
  display:block;
  position:relative;
  width: 100%;
  
  padding-top:2mm;
  
  /*CLEARFIX*/
  overflow: auto;
  &:after {
      content: "";
      clear:both;
      display:table;
  }
`;

const FooterLeft = styled.div`
  display:block;
  position:relative;
  width: 33%;
  float:left;
  
  text-align:center;
`;

const FooterMid = styled.div`
  display:block;
  position:relative;
  width: 33%;
  float:left;
  
  text-align:center;
`;

const FooterRight = styled.div`
  display:block;
  position:relative;
  width: 33%;
  float:left;

  text-align:center;
`;

const PaymentInfo = styled.div`
  display:block;
  position:relative;
  font-size: 0.95em;
`;

const PaymentInfoTitle = styled.div`
  font-weight: bold;
  margin-bottom: 1mm;
`;

const PaymentInfoText = styled.div`
  font-weight: bold;
  margin-bottom: 0.5mm;
`;

export default Invoice;
